import { Link } from "react-router-dom";

export default function Terms() {
    return (
        <main className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-20 min-h-screen">
            <p className="font-mono-tag text-xs uppercase text-brand-saffron mb-3">/ legal</p>
            <h1 data-testid="terms-title" className="font-display font-extrabold text-4xl md:text-6xl tracking-tighter uppercase mb-3">
                Terms & <span className="text-brand-saffron">Conditions</span>
            </h1>
            <p className="font-mono-tag text-[11px] uppercase text-white/50 mb-10">Last updated: Feb 28, 2026</p>

            <div className="prose prose-invert max-w-none space-y-6 text-white/80 leading-relaxed">
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">1. What Primates is</h2>
                    <p>Primates is a <strong className="text-white">discovery-only</strong> marketplace. We list independent Indian fashion startups and link out to their websites. We do not process orders, take payments, or hold inventory. All purchases happen on the brand's own website under their terms.</p>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">2. Your account</h2>
                    <ul className="list-disc pl-6 space-y-1.5">
                        <li>You must be 16 or older to create an account.</li>
                        <li>Keep your password safe. You are responsible for activity on your account.</li>
                        <li>You may use Primates as a shopper (to browse and follow) or as a brand founder (to apply for listing).</li>
                    </ul>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">3. For brands / startups</h2>
                    <ul className="list-disc pl-6 space-y-1.5">
                        <li>Listing is <strong className="text-brand-saffron">not automatic</strong>. Every application is reviewed by our editorial team.</li>
                        <li>You warrant that all information you submit (brand story, images, website, founder details) is accurate and that you own the rights to any content you upload.</li>
                        <li>We may reject or remove any listing at our sole discretion — for example if content is misleading, off-brand, or infringes someone else's IP.</li>
                        <li>You retain full ownership of your content. By uploading, you grant Primates a non-exclusive license to display it on our discovery pages.</li>
                    </ul>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">4. For shoppers</h2>
                    <p>When you click "Visit website" or "Shop drop", you leave Primates. Anything that happens after that — orders, payments, shipping, returns — is between you and the brand. Primates is not a party to the transaction and cannot mediate disputes.</p>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">5. Acceptable use</h2>
                    <p>Don't scrape our data, don't impersonate other brands, don't upload anything unlawful or offensive. We may suspend accounts that break these rules without notice.</p>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">6. Editorial curation</h2>
                    <p>We choose what appears on Primates, in what order, and which brands get an Editor's Pick badge. This is a subjective, editorial decision. Being listed doesn't guarantee any specific placement, volume of traffic, or business outcome.</p>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">7. Liability</h2>
                    <p>Primates is provided "as is". To the extent permitted by law, we're not liable for indirect or consequential losses, including losses arising from your purchase from a listed brand.</p>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">8. Changes</h2>
                    <p>We may update these Terms. If we make a material change we'll flag it on the platform. Continued use after a change means you accept the new terms.</p>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">9. Contact</h2>
                    <p><a href="mailto:primates.work@gmail.com" className="text-brand-saffron hover:underline">primates.work@gmail.com</a></p>
                </section>
            </div>

            <div className="mt-14 border-t border-white/10 pt-8">
                <Link to="/privacy" className="font-mono-tag text-xs uppercase text-brand-saffron hover:underline">Read Privacy Policy →</Link>
            </div>
        </main>
    );
}
